import KT01Content from 'general/components/Contents/KT01Content';
import CustomBreadcrumb from 'general/components/CustomBreadcrumb';
import KT01Footer from 'general/components/Footers/KT01Footer';
import KT01Header2 from 'general/components/Headers/KT01Header2';
import KT01HeaderMobile from 'general/components/Headers/KT01HeaderMobile';
import KTPageError01 from 'general/components/OtherKeenComponents/KTPageError01';
import KTScrollTop from 'general/components/OtherKeenComponents/KTScrollTop';
import KT01Sidebar from 'general/components/Sidebars/KT01Sidebar';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';

KT01BaseLayout.propTypes = {
  isFullScreen: PropTypes.bool,
  isShowFooter: PropTypes.bool,
};

function KT01BaseLayout({ isFullScreen = false, isShowFooter = true, children }) {
  const { user } = useSelector((state) => state.auth);
  // if (_.isEmpty(user)) return <KTPageError01 />

  return (
    <div>
      {/* Header mobile */}
      <KT01HeaderMobile />

      <div className="d-flex flex-column flex-root">
        <div className="d-flex flex-row flex-column-fluid page min-vh-100">
          {/* Sidebar */}
          <KT01Sidebar />

          <div id="kt_wrapper" className="d-flex flex-column flex-row-fluid wrapper">
            {/* Header */}
            <KT01Header2 />

            {/* Breadcrumb */}
            {/* <CustomBreadcrumb /> */}

            {/* Content */}
            <KT01Content isFullScreen={isFullScreen}>{children}</KT01Content>

            {/* Footer */}
            {isShowFooter && <KT01Footer />}
          </div>
        </div>
      </div>

      {/* Scroll Top */}
      <KTScrollTop additionalClassName="bg-success" />
    </div>
  );
}

export default KT01BaseLayout;
